const data = {
    module_name: "ordenes",
    title: "Viajes",
    key: 'ordenes',
    category_key: "ordenes",
    excel_key: "ordenes"
}

module.exports = data